import { render } from "./MemberRole.vue?vue&type=template&id=e313d92a"
import script from "./MemberRole.vue?vue&type=script&lang=js"
export * from "./MemberRole.vue?vue&type=script&lang=js"
script.render = render

export default script